// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"96":"ff2dec","216":"1bb8c9","344":"d2d182","662":"6484cd","818":"ab35fc"}[chunkId] + ".js";
};